import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import { Link } from 'react-router';
import ImageComponent from '../skeleton/ImageComponent';

export const BlogCardLink = styled(Link)(({ theme }) => ({
    display: 'block',
    boxShadow: '0px 4px 12px 4px rgba(63, 81, 181, 0.05)',
    background: theme.palette.common.white,
    borderRadius: '0.8em',
    width: '20em',
    height: '23em',
    cursor: 'pointer',
    '@media (min-width: 550px)': { width: '100%' },
    '@media (min-width: 768px)': { width: '43%' },
    '@media (min-width: 990px)': { width: '20em' },
    '&:link, &:visited, &:focus, &:hover, &:active': {
        color: 'unset',
        textDecoration: 'none',
    },
}));

export const BlogCardThumbnail = styled(ImageComponent)({
    height: '10.5em',
    borderRadius: '10px 10px 0px 0px',
    overflow: 'hidden',
    objectFit: 'cover',
    width: '100%',
});

export const BlogCardContent = styled(Grid)({
    padding: '1.71em',
});

export const BlogCardTitle = styled(Typography)(({ theme }) => ({
    height: '6.28em',
    fontFamily: 'Inter',
    fontSize: '1.28em',
    color: theme.palette.secondary.main,
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize',
    textAlign: 'left',
}));

export const BlogCardSubTitle = styled(Typography)({
    fontFamily: 'Inter',
    fontSize: '1em',
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 400,
});
